import { useMemo } from 'react'

import { getRevenueAndSobByCategory, IRevenueAndSobCategoryRow } from '../../lib'

import { useFinSobAggregationInputs } from './useFinSobAggregationInputs'

export interface IUseFinSobCategoryBreakdownResult {
  fYear: number
  currency: string
  rows: IRevenueAndSobCategoryRow[]
  isPeriodOpen: boolean
}

/** The expanded Revenue & SOB view's per-category breakdown: baseline/plan/expected-exit/actuals
 *  figures for every category in the selected offering, plus a Total row — the same aggregate the
 *  collapsed tile shows, broken out by category. */
export const useFinSobCategoryBreakdown = (): IUseFinSobCategoryBreakdownResult => {
  const {
    targetRows,
    actualsRows,
    quotaRows,
    selectedFYear,
    actualsType,
    isLocalCurrency,
    isYtd,
    currentFQuarter,
    fQuarterActualsPercentage,
    isPeriodOpen,
    currency,
    totalCategory,
  } = useFinSobAggregationInputs()

  const rows = useMemo(
    () =>
      getRevenueAndSobByCategory({
        targetRows,
        actualsRows,
        quotaRows,
        selectedFYear,
        actualsType,
        isLocalCurrency,
        isYtd,
        currentFQuarter,
        fQuarterActualsPercentage,
        isPeriodOpen,
        selectedCategory: totalCategory,
      }),
    [
      targetRows,
      actualsRows,
      quotaRows,
      selectedFYear,
      actualsType,
      isLocalCurrency,
      isYtd,
      currentFQuarter,
      fQuarterActualsPercentage,
      isPeriodOpen,
      totalCategory,
    ]
  )

  return {
    fYear: selectedFYear,
    currency,
    rows,
    isPeriodOpen,
  }
}
